import PubSub from 'services/PubSub/';
import AccountInfo from 'services/AccountInfo/';
import AddressService from 'services/Address/';
import OrdersService from 'services/Orders/';
import StorageService from 'services/StorageService/';
import CartActions from 'actions/Cart';
import CmsService from 'services/CMS'
import {withPersistentCart, balancerWL} from 'config';
import { actionsType, consumer, ecommerce, defaultSC } from 'config/constants'
import DeliverySelectorService from 'services/DeliverySelector'
import AddressFactory from 'factories/Address';
import React from 'react'


const verifyPersistentOrderForm = (data, callbackLogin, closeLogin = () => {}, urlCallback = false) => {
    const { user } = data;
    const currentTime = new Date().getTime();
    let persistentCart = {};
    if (consumer.includes('santaisabel')) {
        persistentCart = user && user.persistentCart ? user.persistentCart.sisa : null;
    } else {
        persistentCart = user && user.persistentCart ? user.persistentCart.jumbo : null;
    }
    let deviceId = StorageService.getItem('deviceId');
    if (withPersistentCart && persistentCart && persistentCart.id && persistentCart?.typeDelivery && (persistentCart.create) >= (currentTime - (1000 * 60 * 60 * 24)) && (deviceId !== persistentCart.deviceId)) {

        OrdersService.getLastOrder(data.token).then(response => {
            const orderFormId = response && response.data ? response.data.orderFormId : false

            if (orderFormId !== persistentCart.id) {
                const storageOrderFormId = StorageService.getItem('orderFormId')

                if (storageOrderFormId !== persistentCart.id) {
                    if ((persistentCart?.typeDelivery === "seller-1-sla-DespachoaDomicilio") || (persistentCart?.typeDelivery === "seller-1-sla-Express")) {
                        _translateAddress(persistentCart?.addressId).then(add => {
                            if (add?.length) {
                                let address = ''
                                closeLogin()
                                address = <><span className="text-delivery">Despacho:</span> <span
                                    className="text-question">{`${add[0].street + ' ' + add[0].number + ', ' + add[0].neighborhood + ', ' + add[0].city + ', ' + add[0].state}`}</span></>

                                PubSub.dispatch('modal_persistentCart_open', {
                                    title: '<span class=\'text\'>Hay productos en el carro</span>',
                                    message: '<span class=\'text-question\'>Tienes productos agregados y un modo de entrega seleccionado</span>',
                                    address: address,
                                    messageTwo: '<span class=\'text-question\'>¿Deseas mantenerlos?</span>',
                                    cancelBtnText: 'Eliminarlos',
                                    confirmBtnText: 'Confirmar',
                                    confirmCallback: () => {
                                        setTimeout(() => {
                                            AddressService.clearAnonymousAdresses()
                                            callbackLogin(false)
                                            StorageService.removeItem('usInfo')
                                            applyPersistentOrderForm(true, user, urlCallback)
                                        }, 0)
                                    },
                                    cancelCallback: () => {
                                        setTimeout(() => {
                                            callbackLogin()
                                            setTimeout(() => {
                                                applyLastShippingAddress()
                                                StorageService.removeItem('usInfo')
                                                if (urlCallback) window.location.href = urlCallback

                                            }, 100)
                                        }, 0)

                                    },
                                })
                            } else {
                                callbackLogin()
                                closeLogin()
                            }
                        })
                    }else if ((persistentCart?.typeDelivery === "seller-1-sla-ClickalAuto") || (persistentCart?.typeDelivery === "seller-1-sla-RetiroenTienda")){
                        _translateStore(persistentCart?.store?.value).then(store => {
                            if (store) {
                                let storeDelivey = ''
                                closeLogin()
                                storeDelivey = <><span className="text-delivery">Retiro:</span> <span
                                    className="text-question">{`${store.address + ', ' + store.name}`}</span></>

                                PubSub.dispatch('modal_persistentCart_open', {
                                    title: '<span class=\'text\'>Hay productos en el carro</span>',
                                    message: '<span class=\'text-question\'>Tienes productos agregados y un modo de entrega seleccionado</span>',
                                    address: storeDelivey,
                                    messageTwo: '<span class=\'text-question\'>¿Deseas mantenerlos?</span>',
                                    cancelBtnText: 'Eliminarlos',
                                    confirmBtnText: 'Confirmar',
                                    confirmCallback: () => {
                                        setTimeout(() => {
                                            AddressService.clearAnonymousAdresses()
                                            callbackLogin(false)
                                            StorageService.removeItem('usInfo')
                                            applyPersistentOrderForm(true, user, urlCallback)
                                        }, 0)
                                    },
                                    cancelCallback: () => {
                                        setTimeout(() => {
                                            callbackLogin()
                                            setTimeout(() => {
                                                applyLastShippingAddress()
                                                StorageService.removeItem('usInfo')
                                                if (urlCallback) window.location.href = urlCallback

                                            }, 100)
                                        }, 0)

                                    },
                                })
                            }else{
                                closeLogin()
                            }
                        })
                    } else {
                        CartActions.getCart()
                        callbackLogin()
                    }

                } else {
                    callbackLogin()
                }
            }else{
                callbackLogin()
            }
        })
    } else{
        callbackLogin()
    }
}

const applyLastShippingAddress = () => {

    let shippingAddress = StorageService.getSecureItem('userData');
    const lastShippingAddress = shippingAddress.lastShippingAddress && shippingAddress.lastShippingAddress.jumbo;
    let address = lastShippingAddress && lastShippingAddress.content;
    let selectedSla = lastShippingAddress && lastShippingAddress.selectedSla;
    let friendlyName = address ? address.logisticsInfo : '';

    if(selectedSla){
        if (selectedSla.indexOf('Click al Auto') !== -1 || selectedSla.indexOf('Retiro en Tienda') !== -1) {
            let typeMethod = selectedSla;
            let treatmentTypeMethod = typeMethod.split('(').shift();
            CmsService.getOperationsV2().then((data) => {
                let stores = data && data.store;
                let matchStore = _getStore(stores, friendlyName);
                if(matchStore && matchStore.sc){
                    let sc = matchStore.sc;
                    let storeName = matchStore.name;
                    _applyDelivery(sc, _trasnlateMethod(treatmentTypeMethod), storeName, treatmentTypeMethod, false)
                }
            })

        } else if (selectedSla.indexOf('Despacho a Domicilio') !==-1 || (selectedSla.indexOf('Despacho Express') !==-1)){
            AddressService.getSalesChannel(address.geoCoordinates[1], address.geoCoordinates[0]).then(salesChannel => {
                if (salesChannel.sc) {
                    let sc = salesChannel.sc;
                    address.geoCoordinate = address.geoCoordinates;
                    _applyDelivery(sc, _trasnlateMethod(selectedSla), address.neighborhood, selectedSla, address);

                }
            });
        }
    } else {
        PubSub.dispatch(actionsType.SET_SALES_CHANNEL);
    }
}


const _getStore = (stores, friendlyName) => {
    if (!stores) return false;
    return stores.find(store => store.value === friendlyName);
}

const _trasnlateMethod = (method) => {

    switch(method){
        case 'Click al Auto':
            return "seller-1-sla-ClickalAuto";
        case 'Retiro en Tienda':
            return "seller-1-sla-RetiroenTienda";
        case 'Despacho a Domicilio':
            return "seller-1-sla-DespachoaDomicilio";
        case 'seller-1-sla-Express':
            return 'Despacho Express';
        default:
            return '';
    }
}

const _applyDelivery = (sc, method, name, nameMethod, selectedAddress = null, simulation = true, seller = null, coordinates = null) =>{
    const responsePromise = {
        data: {
            isDisponible: true
        }
    }

    let consult = simulation ? AddressService.getLogisticSimulation(selectedAddress, sc, nameMethod, seller, coordinates) : Promise.resolve(responsePromise)

    return consult.then(data => {
        if(data.data && data.data.isDisponible) {
            return AddressService.newSetDeliveryMode(method, name, sc, true, selectedAddress, true, undefined, seller, coordinates).then((orderForm) => {
                return orderForm;
            });
        }
        return false;
    })
}


const setPersistentOrderForm = (delivery = null) => {
    if (!withPersistentCart) return false;
    const orderFormId = StorageService.getItem('orderFormId');
    let deviceId = StorageService.getItem('deviceId');
    let userData = StorageService.getSecureItem('userData');
    let addressId = StorageService.getItem('addressSelected');
    const deliveryType = StorageService.getItem('preselected_shipping_method');
    let data = {};
    let storeFields = {};

    return DeliverySelectorService.getCurrent().then(response => {
        if (response?.newStoreSelected && (deliveryType !== 'seller-1-sla-DespachoaDomicilio')) {
            storeFields = {
                value: response?.newStoreSelected?.value,
                sc: response?.newStoreSelected?.sc
            }
            if (consumer.includes('santaisabel')) {
                data = {
                    persistentCart: {
                        jumbo: userData.user && userData.user.persistentCart ? userData.user.persistentCart.jumbo : '',
                        sisa: {
                            id: orderFormId,
                            create: new Date().getTime(),
                            delivery,
                            deviceId: deviceId,
                            store: storeFields,
                            typeDelivery: deliveryType
                        },
                    },
                }
            } else {
                data = {
                    persistentCart: {
                        jumbo: {
                            id: orderFormId,
                            create: new Date().getTime(),
                            delivery,
                            deviceId: deviceId,
                            store: storeFields,
                            typeDelivery: deliveryType
                        },
                        sisa: userData.user && userData.user.persistentCart ? userData.user.persistentCart.sisa : '',
                    },
                }
            }
        } else {
            if (consumer.includes('santaisabel')) {
                data = {
                    persistentCart: {
                        jumbo: userData.user && userData.user.persistentCart ? userData.user.persistentCart.jumbo : '',
                        sisa: {
                            id: orderFormId,
                            create: new Date().getTime(),
                            delivery,
                            deviceId: deviceId,
                            addressId: addressId,
                            typeDelivery: deliveryType
                        },
                    },
                }
            } else {
                data = {
                    persistentCart: {
                        jumbo: {
                            id: orderFormId,
                            create: new Date().getTime(),
                            delivery,
                            deviceId: deviceId,
                            addressId: addressId,
                            typeDelivery: deliveryType
                        },
                        sisa: userData.user && userData.user.persistentCart ? userData.user.persistentCart.sisa : '',
                    },
                }
            }
        }
        return AccountInfo.updtePersistentCart(data)
    })
}

const updateLastShippingAddress = (shippingMode, address = null) => {

    let content = null;

    let shippingAddress = address;

    if (shippingAddress && shippingAddress.address && shippingAddress.address.addressId) {
        content = {
            addressId: shippingAddress.address.addressId,
            addressType: shippingAddress.address.addressType,
            city: shippingAddress.address.city,
            complement: shippingAddress.address.complement,
            country: shippingAddress.address.country,
            geoCoordinates: [shippingAddress.address.geoCoordinates[0], shippingAddress.address.geoCoordinates[1]],
            neighborhood: shippingAddress.address.neighborhood,
            number: shippingAddress.address.number,
            postalCode: shippingAddress.address.postalCode,
            receiverName: shippingAddress.address.receiverName,
            reference: shippingAddress.address.reference,
            state: shippingAddress.address.state,
            street: shippingAddress.address.street,
        }
    } else {
        content = {
            logisticsInfo: shippingAddress.nameStore,
            wareHouseId: shippingAddress.warehouseId,
        }
    }

    let userData = StorageService.getSecureItem('userData')

    let lastShippingInfo = {
        lastShippingAddress : {
            jumbo : {},
            sisa : ''
        }
    };

    if (userData && userData.last_shipping_address && (!userData.lastShippingAddress)) {
        lastShippingInfo.lastShippingAddress.jumbo =  {
            content: userData.last_shipping_address.content,
            selectedSla: userData.last_shipping_address.selectedSla,
        }
    } else {
        lastShippingInfo.lastShippingAddress.jumbo = {
            content: content,
            selectedSla: shippingMode,
        }
        lastShippingInfo.lastShippingAddress.sisa = userData && userData.lastShippingAddress ? userData.lastShippingAddress.sisa : ''
        
    }
    return AccountInfo.updtePersistentCart(lastShippingInfo)
}


const applyPersistentOrderForm = (active, user, urlCallback = false) => {

    if(!active) return false;

    let orderFormId = '';

    if(consumer.includes('santaisabel')){
        orderFormId = user && user.persistentCart ? user.persistentCart.sisa : '';
    }else{
        orderFormId = user && user.persistentCart ? user.persistentCart.jumbo : '';
    }

    StorageService.setItem('orderFormId', orderFormId.id);

    CartActions.getCart().then(() => {
        _applyShippingAddress()
        if(typeof window !== 'undefined') {
            if(urlCallback) window.location.href = urlCallback;
        }
    });
}

const _translateAddress = (id) =>{
    if(!(id && id !== 'null')) return Promise.resolve(false);
 
    return AddressService.get(id).then(results => {
        if (results?.length){
            results[0]["addressId"] = id;
            return results
        }else{
            return false
        }
    })
}

const _translateStore = (storeName) =>{

    return CmsService.getOperationsV2().then((dataStore) => {
        let stores = dataStore && dataStore.store
        let matchStore = _getStore(stores, storeName)

        if (matchStore && matchStore.sc && matchStore.active) {
            return matchStore
        }
    })
}

const _applyShippingAddress = () => {
    let userData = StorageService.getSecureItem('userData');
    let typeMethod = '';
    let addressId = '';
    let store = {};

    if(consumer.includes('santaisabel')){
        typeMethod = userData?.persistentCart?.sisa?.typeDelivery;
        addressId = userData?.persistentCart?.sisa?.addressId;
        store = userData?.persistentCart?.sisa?.store
    }else{

        typeMethod = userData?.persistentCart?.jumbo?.typeDelivery;
        addressId = userData?.persistentCart?.jumbo?.addressId;
        store = userData?.persistentCart?.jumbo?.store
    }

    let address = {};

    if((addressId && addressId !== "null") && (typeMethod === "seller-1-sla-DespachoaDomicilio") || (typeMethod === "seller-1-sla-Express")) {
        _translateAddress(addressId).then(res => {
            if (res?.length) {
                address = res[0];
                if(ecommerce.whiteLabel){
                    AddressService.getSeller(address?.geoCoordinate[1], address?.geoCoordinate[0]).then(response => {
                        if (response.warehouseId) {
                            address.addressGeolocation = address.geoCoordinates;
                            if(balancerWL?.status){
                                _applyDelivery(defaultSC, typeMethod, address.neighborhood, AddressFactory.getFormatedMethod(typeMethod), address, true, response.seller)
                            } else {
                                CmsService.getOperationsV2().then((data) => {
                                    let stores = data && data.store;
                                    let sellerSelected = stores ? stores.filter(store => store.warehouse_id === response.warehouseId) : null;
                                    if(sellerSelected && sellerSelected.length){
                                        sellerSelected = sellerSelected[0].seller;
                                        _applyDelivery(defaultSC, typeMethod, address.neighborhood, AddressFactory.getFormatedMethod(typeMethod), address, true, sellerSelected)
                                    }
                                })
                            }
                        }
                    });
                }else{
                    AddressService.getSalesChannel(address?.geoCoordinate[1], address?.geoCoordinate[0]).then(salesChannel => {
                        if (salesChannel.sc) {
                            let sc = salesChannel.sc;
                            address.geoCoordinates = address.geoCoordinate;
                            _applyDelivery(sc,typeMethod, address.neighborhood, AddressFactory.getFormatedMethod(typeMethod), address);

                        }
                    });
                }
            }
        })
    }else if ((typeMethod === "seller-1-sla-ClickalAuto") || (typeMethod === "seller-1-sla-RetiroenTienda")){
        if(ecommerce.whiteLabel){
            CmsService.getOperationsV2().then((data) => {
                let stores = data && data.store;
                let matchStore = _getStore(stores,store?.value)

                if (matchStore) {
                    let storeName = matchStore.name;
                    let seller = matchStore.seller;
                    let coordinates = matchStore.coordinates.split(',').map((item) => item * 1).reverse();
                    _applyDelivery(defaultSC, typeMethod, storeName,  AddressFactory.getFormatedMethod(typeMethod), false, true, seller,coordinates)
                }
            })
        }else{
            _translateStore(store?.value).then(res => {
                if (res) {
                    const store = res;
                    _applyDelivery(store.sc,typeMethod, store.name, AddressFactory.getFormatedMethod(typeMethod), false);

                }
            })
        }
    }
}





const PersistentCart = {
    verifyPersistentOrderForm,
    setPersistentOrderForm,
    updateLastShippingAddress
}

export default PersistentCart;
